import Vue from "vue";
import Router from "vue-router";
import defaultPages from "./modules/default";
import loggedPages from "./modules/logged";
import shared from "./modules/shared";
import store from "@/state/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...defaultPages, ...loggedPages, ...shared]
});

// Suppress NavigationDuplicated errors globally
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

router.beforeEach((to, from, next) => {
  if (window.innerWidth < 640) {
    store.dispatch("general/updateShowMenu", false);
  }
  // window.scrollTo(0, 0);
  // eslint-disable-next-line no-console
  if (!to.meta.middleware && !to.matched.some(m => m.meta.middleware)) {
    return next();
  } else {
    const middleware =
      to.meta.middleware ||
      to.matched.find(m => m.meta.middleware).meta.middleware;
    const context = {
      to,
      from,
      next,
      store
    };
    return middleware[0]({
      ...context
    });
  }
});

// Access guard: blocks access to routes that declare meta.permission and/or
// meta.roles. A route is allowed if the user is a superadmin, has one of the
// required roles, or has the required permission (mirrors the sidebar logic).
router.beforeEach((to, from, next) => {
  const permission = to.matched.reduce(
    (acc, record) => record.meta.permission || acc,
    null
  );
  const roles = to.matched.reduce(
    (acc, record) => record.meta.roles || acc,
    null
  );
  if ((!permission && !roles) || !store.getters["auth/loggedIn"]) {
    return next();
  }
  const isSuperadmin = store.getters["auth/hasRole"](["superadmin"]);
  const hasRole = roles && store.getters["auth/hasRole"](roles);
  const hasPermission =
    permission && store.getters["auth/userHasPermission"](permission);
  if (isSuperadmin || hasRole || hasPermission) {
    return next();
  }
  return next({ name: "DashboardPage", params: to.params });
});

export default router;
